import React, { useState, useCallback, useEffect, useRef } from "react";
import Heading from "../../../../common/element/Heading";
import Segment from "../../../../common/element/Segment";
import Table from "../../../../common/element/Table";
import Badge from "../../../../common/element/Badge";
import Tag from "../../../../common/element/Tag";
import Scrollbar from "../../../../common/element/ScrollBar";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import Dialog from "../../../../common/element/Dialog";
import Progress from "../../../../common/element/Progress/Progress";
import { useDispatch, useSelector } from "react-redux";
import { setBreadcrumbs } from "../../../../redux/classes/breadcrumbsSlice";
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
import { UpdateCheckExistUser } from "../../../../redux/classes/provider-portal/checkExistUser";
import moment from "moment";
import { useParams, Link, useNavigate } from "react-router-dom";
import { GetAllSpecificProviderWorkerInd } from "../../../../actions/provider-portal/GetSpecificProviderWorkerInd";
import { SpecificProviderWorkerComplianceStatus, SpecificProviderClientComplianceStatus } from "../../../../actions/provider-portal/GetAllWorkerAndClientTotal";
import SearchImg from "../../../../assets/icons-svg/search-lg.svg";
import ClientInput from "../../../../common/element/Input/clientInput";
import useCallbackRef from "../../../../common/element/hooks/useCallbackRef";
import Tooltip from "../../../../common/element/Tooltip";
import { debounce } from "../../../../common/snippet/Debouncing";

// import {
//   MarkTaskAsRead
// } from "../../../../actions/Admin";
import { MarkTaskAsRead } from "../../../../actions/provider-portal/MarkTaskAsRead";
import { UpdateTaskArchiveStatus } from "../../../../actions/provider-portal/UpdateTaskArchiveStatus";
import { GetAllDeshboardTasks } from "../../../../actions/provider-portal/GetAllDeshboardTasks";
import { GetClientDashboardDueInvoicesByDays } from "../../../../actions/provider-portal/invoices/GetClientDashboardDueInvoicesByDays";
import InviteClientPaymentExistUser from "../Registration/InviteClientPaymentExistUser";
// import PieChart from "./PieChartUnderAClient";
import TotalClientAndWorker from "./TotalClientAndWorker";
import ExpiredSubscription from "../../components/template/ExpiredSubscription";
import { GetProviderDashboardDueInvoicesByDays } from "../../../../actions/provider-portal/invoices/GetProviderDashboardDueInvoicesByDays";
const Dashboard = () => {
  const navigate = useNavigate();
  const [providerFunctionId, setProviderfunctionId] = useState("")
  const AllFunctions = useSelector((state) => state.allFunctions);
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(true);
  const { ProviderExistingUser } = useSelector((state) => state);
  const isSubscribed = useSelector((state) => state?.providerSubscription?.isSubscribed);
  const [checkSubscription, setCheckSubscription] = useState(false)
  const { id } = useParams();
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const { ProviderContactData } = useSelector((state) => state);
  // useEffect(() => {
  //   setCheckSubscription(isSubscribed ? true : false)
  // }, [checkSubscription])
  useEffect(() => {
    // Set breadcrumbs when the component mounts
    dispatch(
      setBreadcrumbs([{ label: "Dashboard", url: "/provider/dashboard" }])
    );
  }, []);
  useEffect(() => {

    if (AllFunctions?.allFunction) {
      let functionType = AllFunctions?.allFunction.filter(
        (item) => item?.function_name === "provider" // client function id 
      );
      setProviderfunctionId(functionType[0]?.function_id);
    }
  }, []);
  let function_assignment_id;
  const { Tr, Th, Td, THead, TBody } = Table;
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [invoiceData, SetInvoiceData] = useState(false);
  const [counts, setCounts] = useState([]);
  const [totalWorker, setTotalWorker] = useState(null)
  const [totalClinet, setTotalClient] = useState(null);
  const [workerIndData, setWorkerIndData] = useState([]);
  const loginData = JSON.parse(localStorage.getItem("LoginUserData"));
  const conserve_authtoken = localStorage.getItem("conserve_authtoken");
  const userId = loginData?.userName?.user_id || loginData?.data?.user_id;
  const userRole = "provider";
  const organisation_id = loginData?.organisation_id;
  const [totalTastCount, setTotalTaskCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const scrollContainerRef = useRef(null);
  const [scrollThreshold, setScrollThreshold] = useState(23);
  const [limit, setLimit] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [notificationList, setNotificationList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleSegmentValue, setSingleSegmentValue] = useState(["Inbox"]);

  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setSingleSegmentValue(val);
    },
    [setSingleSegmentValue]
  );

  const today = moment().startOf("day");
  const yesterday = moment().subtract(1, "day").startOf("day");
  const startOfWeek = moment().startOf("week");
  const startOfMonth = moment().startOf("month");
  const startOfYear = moment().startOf("year");
  const groupedNotifications = notificationList?.reduce(
    (acc, notification) => {
      const createdDate = moment(notification?.created_date);
      if (createdDate.isSame(today, "d")) {
        acc.today.push(notification);
      } else if (createdDate.isSame(yesterday, "d")) {
        acc.yesterday.push(notification);
      } else if (createdDate.isSameOrAfter(startOfWeek)) {
        acc.thisWeek.push(notification);
      } else if (createdDate.isSameOrAfter(startOfMonth)) {
        acc.thisMonth.push(notification);
      } else if (createdDate.isSameOrAfter(startOfYear)) {
        acc.thisYear.push(notification);
      } else {
        acc.earlier.push(notification);
      }
      return acc;
    },
    {
      today: [],
      yesterday: [],
      thisWeek: [],
      thisMonth: [],
      thisYear: [],
      earlier: [],
    }
  );

  const FetchAllSpecificProviderWorkerInd = useCallback(() => {
    // setIsFetching(true);
    const payload = {
      provider_org_id: storedData?.organisation_id,
    };

    dispatch(GetAllSpecificProviderWorkerInd(payload))
      .then((res) => {
        if (res?.success === true) {
          const arrayData = res?.data;
          setWorkerIndData(arrayData);

          // Handle the arrayData as needed
        } else {
          // Optionally handle the failure case
          console.error("Failed to fetch data");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const OnSpecificProviderWorkerComplianceStatus = useCallback(() => {
    const payload = {
      provider_org_id: storedData?.organisation_id,
    };
    dispatch(
      SpecificProviderWorkerComplianceStatus(payload)
    )
      .then((res) => {
        if (res?.success === true) {
          const arrayData = res?.data;
          setTotalWorker(arrayData) //set worker details
          // Handle the arrayData as needed
        } else {
          // Optionally handle the failure case
          console.error("Failed to fetch data");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const OnSpecificProviderClientComplianceStatus = useCallback(() => {
    if (providerFunctionId) {
      const payload = {
        provider_fa_id: storedData?.function_assignment_id,
        provider_org_id: storedData?.organisation_id,
        function_id: providerFunctionId
      }
      dispatch(
        SpecificProviderClientComplianceStatus(payload)
      )
        .then((res) => {
          if (res?.success === true) {
            const arrayData = res?.data;
            setTotalClient(arrayData) //set Client details
            // Handle the arrayData as needed
          } else {
            // Optionally handle the failure case
            console.error("Failed to fetch data");
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [dispatch,providerFunctionId]);

  useEffect(() => {
    OnSpecificProviderWorkerComplianceStatus() //worker
    FetchAllSpecificProviderWorkerInd();
  }, []);

  useEffect(()=>{
      OnSpecificProviderClientComplianceStatus()
  },[providerFunctionId])

  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = scrollContainerRef.current;
      if (
        scrollContainer &&
        scrollContainer.scrollTop >= scrollThreshold &&
        !isFetching &&
        notificationList?.length < totalCount
      ) {
        setLimit((prevLimit) => prevLimit + 10);
        setScrollThreshold((prevThreshold) => prevThreshold + 150);
      }
    };
    const scrollContainer = scrollContainerRef.current;
    scrollContainer?.addEventListener("scroll", handleScroll);

    return () => {
      scrollContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [isFetching, scrollThreshold, totalCount, notificationList]);
  const GetTasksNotifications = useCallback(() => {
    // setIsFetching(true);
    const payload = {
      limit: limit,
      role_name: userRole,
      user_id: userId,
      is_archived: singleSegmentValue[0] == "Inbox" ? false : true,
      organisation_id: organisation_id,
      search: searchTerm,
    };
    dispatch(GetAllDeshboardTasks(payload)).then((res) => {
      // setIsFetching(false);
      if (res?.success === true) {
        const arrayData = res?.data?.rows;
        setNotificationList(arrayData);
        setTotalTaskCount(res?.data?.unreadCount);
        setTotalCount(res?.data?.count);
      }
    });
  }, [dispatch, singleSegmentValue, searchTerm, limit]);
  useEffect(() => {
    GetTasksNotifications();
  }, [singleSegmentValue, searchTerm, limit]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.trim());
  };
  const inputchangehandler = useCallbackRef(debounce(handleSearch), []);

  const archiveTask = (notify) => {
    const payload = {
      role_name: userRole,
      notification_id: notify.notification_id,
      is_archived: true,
      user_id: userId,
    };
    dispatch(UpdateTaskArchiveStatus(payload)).then((res) => {
      if (res?.success === true) {
        GetTasksNotifications();
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  const onMarkAsRead = (notifyId) => {
    const payload = {
      role_name: userRole,
      notification_id: notifyId,
      user_id: userId,
      task_read: true,
    };
    dispatch(MarkTaskAsRead(payload)).then((res) => {
      if (res?.success === true) {
        setTotalTaskCount(totalTastCount - 1); // Fixed typo: 'totalTastCount' -> 'totalTaskCount'
        setNotificationList((prevList) => {
          return prevList.map((item) => {
            if (item?.notification_id === notifyId) {
              return { ...item, task_read: true };
            }
            return item;
          });
        });
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  const { checkExistUser } = useSelector((state) => state);
  // checkExistUser.checkAcceptUser

  useEffect(() => {
    if (checkExistUser.checkAcceptUser) {
      setDialogIsOpen(true);
    }
  }, [checkExistUser]);

  const onDialogClose = () => {
    if (checkExistUser.checkAcceptUser) {
      dispatch(
        UpdateCheckExistUser({
          checkUser: false,
          path: "",
          login: false,
          checkAcceptUser: false,
        })
      );
    }
    setDialogIsOpen(false);
  };

  useEffect(() => {
    dispatch(
      GetProviderDashboardDueInvoicesByDays({
        provider_org_id: storedData?.organisation_id,
      })
    ).then((response) => {
      if (response.success) {
        SetInvoiceData(response.data);
      }
    });
  }, []);
  return (
    <React.Fragment>
      {isSubscribed ? <ExpiredSubscription /> :
        <>
          <Heading className="mb-4">Dashboard</Heading>
          <div className="grid grid-container gap-8">
            <div className="flex gap-8 flex-col">
              <div className="bg-white py-6 rounded-xl dark-shadow">
                <div className="card-header flex justify-between border-b border-gray-200 pb-5 px-6 mb-3">
                  <span className="text-gray-900 text-base font-semibold flex items-center">
                    <span className="mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M6 15L8 17L12.5 12.5M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Tasks{" "}
                    <Tag className="text-blue-800 bg-blue-100 ml-2">
                      {totalTastCount}
                    </Tag>
                  </span>
                  {/* <BtnLight className="w-20 h-9">View All</BtnLight> */}
                </div>
                <div className="flex justify-between mb-3 px-4">
                  <Segment
                    className="docType-btn"
                    value={singleSegmentValue[0] == "Inbox" ? "Inbox" : "Archive"}
                    onChange={(val) => onSingleSelectionSegmentChange(val)}
                  >
                    <Segment.Item value="Inbox">Inbox</Segment.Item>
                    <Segment.Item value="Archive">Archive</Segment.Item>
                  </Segment>
                  <div className="w-80 h-10">
                    <div className="input-wrapper">
                      <div className="input-suffix-start left-3.5">
                        <img src={SearchImg} alt="" className="h-5" />
                      </div>
                      <ClientInput
                        type="text"
                        className="input  pl-10 w-80  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Search"
                        inputchangehandler={inputchangehandler}
                        name={"search"}
                      />
                    </div>
                  </div>
                </div>
                <div
                  ref={scrollContainerRef}
                  className="notification-list-container overflow-y-auto max-h-[839px]"
                >
                  <Table className="min-w-full whitespace-nowrap">
                    <THead>
                      <Tr>
                        <Th className="pl-6 w-1/2	">Notification</Th>
                        <Th>Timestamp</Th>
                        <Th className="w-84">Company</Th>
                        {singleSegmentValue[0] == "Inbox" && (
                          <Th className="">Action</Th>
                        )}
                      </Tr>
                    </THead>
                    <tbody className={`overflow-y-auto notification-list `}>
                      {loading ? (
                        <tr>
                          <td colSpan="4" className="text-center p-4">
                            Loading...
                          </td>
                        </tr>
                      ) : notificationList.length === 0 ? (
                        <tr>
                          <td colSpan="4" className="text-center p-4">
                            No data available
                          </td>
                        </tr>
                      ) : (
                        <>
                          {groupedNotifications.today.length > 0 && (
                            <>
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-blue-700 font-bold px-6 py-2 mt-2"
                                >
                                  Today
                                </td>
                              </tr>
                              {groupedNotifications.today.map((notif) => (
                                <React.Fragment key={notif.notification_id}>
                                  <tr>

                                    <td className="flex justify-between  px-6 hover:bg-blue-50">
                                      <Link
                                        className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                        to="#"
                                        onClick={() =>
                                          !notif?.task_read && onMarkAsRead(notif.notification_id)
                                        }
                                      >
                                        {notif?.task_read === true ? (
                                          <div width="10" height="10"></div>
                                        ) : (
                                          <svg
                                            className="self-center"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                          </svg>
                                        )}
                                        <Tooltip title={notif.message}>
                                          <span className="text-gray-700 w-72 noti-newwrap">
                                            {notif.message}
                                          </span>
                                        </Tooltip>
                                      </Link>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <span >
                                        {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                      </span>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <Tooltip title={notif.trading_name}>
                                        <span className="w-32 noti-newwrap cursor-pointer">
                                          {notif?.trading_name ? notif.trading_name : "-"}
                                        </span>
                                      </Tooltip>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      {singleSegmentValue[0] === "Inbox" && (
                                        <span
                                          className="text-blue-700 font-semibold cursor-pointer"
                                          onClick={() => archiveTask(notif)}
                                        >
                                          {notif?.action ? notif.action : "Archive"}
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}


                            </>
                          )}
                          {groupedNotifications.yesterday.length > 0 && (
                            <>
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-blue-700 font-bold px-6 py-2 mt-2"
                                >
                                  Yesterday
                                </td>
                              </tr>
                              {groupedNotifications.yesterday.map((notif) => (
                                <React.Fragment key={notif.notification_id}>
                                  <tr>

                                    <td className="flex justify-between  px-6 hover:bg-blue-50">
                                      <Link
                                        className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                        to="#"
                                        onClick={() =>
                                          !notif?.task_read && onMarkAsRead(notif.notification_id)
                                        }
                                      >
                                        {notif?.task_read === true ? (
                                          <div width="10" height="10"></div>
                                        ) : (
                                          <svg
                                            className="self-center"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                          </svg>
                                        )}
                                        <Tooltip title={notif.message}>
                                          <span className="text-gray-700 w-72 noti-newwrap">
                                            {notif.message}
                                          </span>
                                        </Tooltip>
                                      </Link>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <span >
                                        {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                      </span>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <Tooltip title={notif.trading_name}>
                                        <span className="w-32 noti-newwrap cursor-pointer">
                                          {notif?.trading_name ? notif.trading_name : "-"}
                                        </span>
                                      </Tooltip>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      {singleSegmentValue[0] === "Inbox" && (
                                        <span
                                          className="text-blue-700 font-semibold cursor-pointer"
                                          onClick={() => archiveTask(notif)}
                                        >
                                          {notif?.action ? notif.action : "Archive"}
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}


                            </>
                          )}
                          {groupedNotifications.thisWeek.length > 0 && (
                            <>
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-blue-700 font-bold px-6 py-2 mt-2"
                                >
                                  This week
                                </td>
                              </tr>
                              {groupedNotifications.thisWeek.map((notif) => (
                                <React.Fragment key={notif.notification_id}>
                                  <tr>
                                    <td className="flex justify-between py-1.5 px-6 hover:bg-blue-50">
                                      <Link
                                        className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                        to="#"
                                        onClick={() =>
                                          !notif?.task_read && onMarkAsRead(notif.notification_id)
                                        }
                                      >
                                        {notif?.task_read === true ? (
                                          <div width="10" height="10"></div>
                                        ) : (
                                          <svg
                                            className="self-center"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                          </svg>
                                        )}
                                        <Tooltip title={notif.message}>
                                          <span className="text-gray-700 w-72 noti-newwrap">
                                            {notif.message}
                                          </span>
                                        </Tooltip>
                                      </Link>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <span >
                                        {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                      </span>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <Tooltip title={notif.trading_name}>
                                        <span className="w-32 noti-newwrap cursor-pointer">
                                          {notif?.trading_name ? notif.trading_name : "-"}
                                        </span>
                                      </Tooltip>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      {singleSegmentValue[0] === "Inbox" && (
                                        <span
                                          className="text-blue-700 font-semibold cursor-pointer"
                                          onClick={() => archiveTask(notif)}
                                        >
                                          {notif?.action ? notif.action : "Archive"}
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}


                            </>
                          )}
                          {groupedNotifications.thisMonth.length > 0 && (
                            <>
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-blue-700 font-bold px-6 py-2 mt-2"
                                >
                                  This month
                                </td>
                              </tr>


                              {groupedNotifications.thisMonth.map((notif) => (
                                <React.Fragment key={notif.notification_id}>
                                  <tr>

                                    <td className="flex justify-between  px-6 hover:bg-blue-50">
                                      <Link
                                        className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                        to="#"
                                        onClick={() =>
                                          !notif?.task_read && onMarkAsRead(notif.notification_id)
                                        }
                                      >
                                        {notif?.task_read === true ? (
                                          <div width="10" height="10"></div>
                                        ) : (
                                          <svg
                                            className="self-center"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                          </svg>
                                        )}
                                        <Tooltip title={notif.message}>
                                          <span className="text-gray-700 w-72 noti-newwrap">
                                            {notif.message}
                                          </span>
                                        </Tooltip>
                                      </Link>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <span >
                                        {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                      </span>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <Tooltip title={notif.trading_name}>
                                        <span className="w-32 noti-newwrap cursor-pointer">
                                          {notif?.trading_name ? notif.trading_name : "-"}
                                        </span>
                                      </Tooltip>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      {singleSegmentValue[0] === "Inbox" && (
                                        <span
                                          className="text-blue-700 font-semibold cursor-pointer"
                                          onClick={() => archiveTask(notif)}
                                        >
                                          {notif?.action ? notif.action : "Archive"}
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}


                            </>
                          )}
                          {/* --0--------------------------------------------- */}
                          {groupedNotifications.thisYear.length > 0 && (
                            <>
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-blue-700 font-bold px-6 py-2 mt-2"
                                >
                                  This year
                                </td>
                              </tr>
                              {groupedNotifications.thisYear.map((notif) => (
                                <React.Fragment key={notif.notification_id}>
                                  <tr>

                                    <td className="flex justify-between  px-6 hover:bg-blue-50">
                                      <Link
                                        className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                        to="#"
                                        onClick={() =>
                                          !notif?.task_read && onMarkAsRead(notif.notification_id)
                                        }
                                      >
                                        {notif?.task_read === true ? (
                                          <div width="10" height="10"></div>
                                        ) : (
                                          <svg
                                            className="self-center"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                          </svg>
                                        )}
                                        <Tooltip title={notif.message}>
                                          <span className="text-gray-700 w-72 noti-newwrap">
                                            {notif.message}
                                          </span>
                                        </Tooltip>
                                      </Link>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <span >
                                        {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                      </span>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      <Tooltip title={notif.trading_name}>
                                        <span className="w-32 noti-newwrap cursor-pointer">
                                          {notif?.trading_name ? notif.trading_name : "-"}
                                        </span>
                                      </Tooltip>
                                    </td>
                                    <td className="px-4 py-1.5">
                                      {singleSegmentValue[0] === "Inbox" && (
                                        <span
                                          className="text-blue-700 font-semibold cursor-pointer"
                                          onClick={() => archiveTask(notif)}
                                        >
                                          {notif?.action ? notif.action : "Archive"}
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}


                            </>
                          )}
                        </>
                      )}
                    </tbody>
                    {isFetching && (
                      <div className="flex justify-center py-4">
                        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-blue-600"></div>
                      </div>
                    )}
                  </Table>
                </div>
              </div>
              <div className="bg-white py-6 border border-gray-200 rounded-xl dark-shadow">
                <div className="px-6">
                  <div className="card-header flex justify-between border-b border-gray-200 pb-5 mb-3">
                    <div className="flex items-center">
                      <span className="mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            d="M9.35156 14.6667C9.35156 15.9553 10.3962 17 11.6849 17H13.8516C15.2323 17 16.3516 15.8807 16.3516 14.5C16.3516 13.1193 15.2323 12 13.8516 12H11.8516C10.4709 12 9.35156 10.8807 9.35156 9.5C9.35156 8.11929 10.4709 7 11.8516 7H14.0182C15.3069 7 16.3516 8.04467 16.3516 9.33333M12.8516 5.5V7M12.8516 17V18.5M22.8516 12C22.8516 17.5228 18.3744 22 12.8516 22C7.32871 22 2.85156 17.5228 2.85156 12C2.85156 6.47715 7.32871 2 12.8516 2C18.3744 2 22.8516 6.47715 22.8516 12Z"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <p></p>
                      <div className="flex flex-col">
                        <span className="text-gray-900 text-base font-semibold">
                          Invoices
                        </span>
                        <p className="text-gray-600">Due in the next 30 days </p>
                      </div>
                    </div>
                    <BtnLight
                      className="w-20"
                      onClick={() => navigate("/provider/invoices")}
                    >
                      View All
                    </BtnLight>
                  </div>
                </div>

                <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
                  <div>
                    <div className="px-6">
                      <div className="overflow-hidden border rounded-lg border-gray-200">
                        <Table>
                          <TBody>
                            {invoiceData?.length > 0 &&
                              invoiceData?.length != undefined &&
                              invoiceData?.map((item, index) => {
                                let status;
                                const renewalDate = new Date(
                                  item?.upcoming_inv_renewal_date
                                );
                                const currentDate = new Date();
                                if (renewalDate < currentDate) {
                                  status = "Overdue";
                                } else {
                                  status = "Upcoming";
                                }

                                return (
                                  <Tr>
                                    <Td>{item?.xero_invoice_number}</Td>
                                    <Td>
                                      {status && (
                                        <Tag
                                          className={`${status == "Upcoming"
                                            ? "bg-warning-50 text-warning-700"
                                            : "bg-error-50 text-error-700"
                                            } `}
                                        >
                                          <span>
                                            <svg
                                              width="12"
                                              height="12"
                                              viewBox="0 0 12 12"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g clip-path="url(#clip0_18999_70113)">
                                                <path
                                                  d="M11.35 5.75L10.3503 6.75L9.34998 5.75M10.4725 6.5C10.4907 6.33583 10.5 6.169 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C7.41363 10.5 8.67502 9.84817 9.5 8.82867M6 3.5V6L7.5 7"
                                                  stroke={` ${status == "Upcoming"
                                                    ? "#F79009"
                                                    : "red"
                                                    }`}
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_18999_70113">
                                                  <rect
                                                    width="12"
                                                    height="12"
                                                    fill="white"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                          </span>{" "}
                                          {status}
                                        </Tag>
                                      )}
                                    </Td>
                                    <Td>
                                      {item?.invoice_send_date
                                        ? moment(item?.invoice_send_date).format(
                                          "DD/MM/YYYY"
                                        )
                                        : "-"}
                                    </Td>
                                  </Tr>
                                );
                              })}
                            {(invoiceData?.length == 0 ||
                              invoiceData?.length == undefined) && (
                                <Td colSpan="2" className="text-center p-4">
                                  No upcoming invoices
                                </Td>
                              )}
                          </TBody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-8 flex-col">
              {/* Total Client */}
              <TotalClientAndWorker
                chartData={totalClinet}
                title={"Clients"}
                redirectPath={"/provider/clients"}
              />

              {/* Total Worker */}
              <TotalClientAndWorker
                chartData={totalWorker}
                title={"Workers"}
                redirectPath={"/provider/workers"}
              />

              <div className="bg-white py-6 border border-gray-200 rounded-xl dark-shadow">
                <div className="px-6">
                  <div className="card-header flex border-b border-gray-200 pb-5 items-center mb-5">
                    <span className="mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <div className="flex flex-col">
                      <span className="text-gray-900 text-base font-semibold">
                        Workers Inductions
                      </span>
                      <p className="text-gray-600">Pending completion</p>
                    </div>
                  </div>
                </div>
                <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
                  <div>
                    <div className="px-6">
                      <div className="overflow-hidden border rounded-lg border-gray-200">
                        <Table>
                          <TBody>
                            {workerIndData &&
                              workerIndData?.length > 0 &&
                              workerIndData.map((item, index) => (
                                <Tr
                                  className="cursor-pointer"
                                  key={index}
                                  onClick={() => navigate("/provider/workers")}
                                >
                                  <Td>{`${item?.assignWorker?.worker_individual?.first_name} ${item?.assignWorker?.worker_individual?.last_name}`}</Td>
                                  <Td>
                                    {item?.clientAssign?.clientCompInd?.[0]?.company_ind_name}{" "}
                                    <span className="block text-gray-600">
                                      {item?.trading_name}{" "}
                                      {/* You may replace client_org_id with actual client name if you have that information */}
                                    </span>
                                  </Td>
                                  <Td className="w-28">
                                    <Tag
                                      className={
                                        item.completion_status === "Complete"
                                          ? "bg-gray-100 text-gray-700"
                                          : item.completion_status ===
                                            "Awaiting action"
                                            ? "bg-blue-50 text-blue-800"
                                            : "bg-gray-100 text-gray-700"
                                      }
                                    >
                                      {item?.completion_status ? item?.completion_status : "Pending"}
                                    </Tag>
                                  </Td>
                                </Tr>
                              ))}

                            {workerIndData.length === 0 && (
                              <Tr  >
                                <Td className="text-center p-4">No data available</Td>
                              </Tr>)}
                          </TBody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Dialog
            isOpen={dialogIsOpen}
            onClose={onDialogClose}
            onRequestClose={() => console.log("")
            }
            bodyOpenClassName="overflow-hidden"
          >
            <div className="flex border-b mb-5 pb-5 px-6 pt-6">
              <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
                <img src="/assets/icons-svg/building.svg" alt="" />
              </span>
              <div>
                <h5 className="mb-1 text-gray-900 text-base font-semibold">
                  Connect with {ProviderExistingUser?.trading_name ? ProviderExistingUser?.trading_name : "N/A"}
                </h5>
                <p className="text-gray-600 ">
                  Ensure a successful connection with the client by completing these
                  steps
                </p>
              </div>
            </div>
            <InviteClientPaymentExistUser

              onDialogClose={onDialogClose}
              ProviderExistingUser={ProviderExistingUser}
              GetProviderChecklistByClient={{
                provider_org_id: loginData?.organisation_id,
                client_org_id:
                  ProviderContactData?.provInviteClient?.org_data?.organisation_id,
                token: conserve_authtoken,
              }}
            />
          </Dialog>


        </>}

    </React.Fragment>
  );
};

export default Dashboard;
